import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Button, Icon, Layout, Menu, Tooltip } from 'antd';
import cx from 'classnames'
import _ from 'lodash';

import { updateConfig } from '../../services/config/actions';
import * as configController from '../../services/api/config';
import logo from './logo.png';
import './DashboardPage.scss';

const { Content, Sider } = Layout;
const { Item: MenuItem, SubMenu } = Menu;

export class DashboardPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedKey: '',
            selectedSubMenu: [],
            isMenuOpened: false
        };
    }

    getMenuStatus() {
        const { location } = this.props
        const { selectedSubMenu } = this.state;
        const url = location.pathname;
        const subMenuKey = url.substring(0, url.lastIndexOf('/'));
        let newState = { selectedKey: url };

        if (subMenuKey !== '/dashboard')
            newState.selectedSubMenu = _.concat(selectedSubMenu, subMenuKey)

        this.setState(newState);
    }

    getConfig() {
        const { updateConfig } = this.props;

        configController.getConfigs()
            .then((res) => res.json())
            .then((json) => updateConfig(json.config))
    }

    handleSubMenuClick({ key, e }) {
        const { selectedSubMenu } = this.state
        if (selectedSubMenu.includes(key)) {
            _.remove(selectedSubMenu, (selectedKey) => selectedKey === key)
            this.setState({ selectedSubMenu })
        } else {
            this.setState({ selectedSubMenu: _.concat(selectedSubMenu, key) })
        }
    }

    handleLogout(e) {
        const { history } = this.props;
        localStorage.removeItem('jwt');
        history.push('/login');
    }

    componentDidMount() {
        this.getMenuStatus();
        this.getConfig();
    }

    componentDidUpdate(prevProps, prevState) {
        const { location } = this.props

        if (prevProps.location.pathname !== location.pathname) {
            this.getMenuStatus();
            this.getConfig();
        }
    }

    renderAdminMenuItem() {
        return (
            <SubMenu key="/dashboard/admin" title="Admin Section" onTitleClick={(obj) => this.handleSubMenuClick(obj)}>
                <MenuItem key="/dashboard/admin/programme">
                    <NavLink to="/dashboard/admin/programme" activeClassName="active-link">
                        <span>Programme</span>
                    </NavLink>
                </MenuItem>
                <MenuItem key="/dashboard/admin/channel">
                    <NavLink to="/dashboard/admin/channel" activeClassName="active-link">
                        <span>Channel</span>
                    </NavLink>
                </MenuItem>
                <MenuItem key="/dashboard/admin/customer">
                    <NavLink to="/dashboard/admin/customer" activeClassName="active-link">
                        <span>Customer</span>
                    </NavLink>
                </MenuItem>
                <MenuItem key="/dashboard/admin/ipoints-sync">
                    <NavLink to="/dashboard/admin/ipoints-sync" activeClassName="active-link">
                        <span>i-Points Sync</span>
                    </NavLink>
                </MenuItem>
                <MenuItem key="/dashboard/admin/consultant">
                    <NavLink to="/dashboard/admin/consultant" activeClassName="active-link">
                        <span>Consultant</span>
                    </NavLink>
                </MenuItem>
                <MenuItem key="/dashboard/admin/config">
                    <NavLink to="/dashboard/admin/config" activeClassName="active-link">
                        <span>Config</span>
                    </NavLink>
                </MenuItem>
            </SubMenu>
        )
    }

    render() {
        const { history, name, isAdmin } = this.props;
        const { selectedKey, selectedSubMenu, isMenuOpened } = this.state;

        return (
            <Layout className="DashboardPage">
                <div className="mobile-menu">
                    <div className="menu-header">
                        <img className="logo" src={logo} alt="Informatics Logo"/>
                        <Icon className="menu-toggle-btn" type={ isMenuOpened ? 'close' : 'bars' } onClick={(e) => this.setState({ isMenuOpened: !isMenuOpened })}/>
                    </div>
                    <div className={cx('menu-list', { 'hidden': !isMenuOpened })}>
                        <Menu 
                            theme="dark" 
                            mode="inline"
                            className="Menu"
                            selectedKeys={[selectedKey]}
                            openKeys={selectedSubMenu}
                        >
                            <MenuItem key="/dashboard/lead">
                                <NavLink to="/dashboard/lead" activeClassName="active-link">
                                    <span>Lead</span>
                                </NavLink>
                            </MenuItem>
                            <MenuItem key="/dashboard/profile">
                                <NavLink to="/dashboard/profile" activeClassName="active-link">
                                    <span>Profile</span>
                                </NavLink>
                            </MenuItem>
                            { isAdmin && this.renderAdminMenuItem() }
                        </Menu>
                        <Button className="logout-btn" onClick={(e) => this.handleLogout(e)}>Logout</Button>
                    </div>
                </div>
                <Sider
                    className="Sider"
                    trigger={null}
                >
                    <div className="menu-header">
                        <img className="sider-logo" src={logo} alt="Informatics Logo"/>
                        <div className="briefing">
                            Welcome back,
                            <br/>
                            <b>{name}</b>
                        </div>
                    </div>
                    <Menu 
                        theme="dark" 
                        mode="inline"
                        className="Menu"
                        selectedKeys={[selectedKey]}
                        openKeys={selectedSubMenu}
                    >
                        <MenuItem key="/dashboard/lead">
                            <NavLink to="/dashboard/lead" activeClassName="active-link">
                                <span>Lead</span>
                            </NavLink>
                        </MenuItem>
                        <MenuItem key="/dashboard/profile">
                            <NavLink to="/dashboard/profile" activeClassName="active-link">
                                <span>Profile</span>
                            </NavLink>
                        </MenuItem>
                        { isAdmin && this.renderAdminMenuItem() }
                    </Menu>
                    <Button className="logout-btn" onClick={(e) => this.handleLogout(e)}>Logout</Button>
                </Sider>
                <Layout>
                    <Content>
                        {this.props.children}
                        <div className="home-btn" onClick={(e) => history.push('/dashboard/lead/new')}>
                            <Tooltip placement="top" title="Create Lead">
                                    <Icon type="plus" />
                            </Tooltip>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        name: state.user.name,
        isAdmin: state.user.isAdmin
    });
};

export default connect(mapStateToProps, { updateConfig })(DashboardPage);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/DashboardPage.js